import React from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons'
import { Row, Col, Select, InputNumber, Divider } from 'antd';
import { getYLabel } from '../../../../services/helper/sparameter/utility';

const { Option } = Select;
const attr = {
  type: "flex",
  justify: "space-around",
  align: "middle"
}

const SparameterSetting = (props) => {
  const { axis, actions, setting, XSettingUnit, settingShow, settingTitleClick, portSelect } = props;
  const { value, parameter } = setting;
  const { showAxisSetting, axisChange, changeRange, axisRangeKeyDown, XUnitChange, updateRange, savePrevRange } = actions;
  return (
    <div className='parameter-setting-box'>
      <Divider orientation="left" style={{ marginTop: 8, marginBottom: 6, marginLeft: 12 }}>
        <span onClick={settingTitleClick} className='result-import-title'>
          {settingShow ? <DownOutlined className="title-expand-icon" /> : <RightOutlined className="title-expand-icon" />}
          <span className='pdn-result-menu-title'>Setting</span>
        </span>
      </Divider>
      <div style={{ display: settingShow ? 'block' : 'none' }}>
        <Row onClick={() => showAxisSetting('xShow')} className='sp-axis-title'>
          {axis.xShow ? <DownOutlined className="result-setting-expand-icon" /> : <RightOutlined className="result-setting-expand-icon" />}
          <span className='setting-input-title'>X axis -- Frequency</span>
        </Row>
        <Row style={{ display: axis.xShow ? 'block' : 'none' }} className='sp-axis-content'>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>Scale</label>
            </Col>
            <Col span={14}>
              <Select
                value={axis.xScale}
                className='sp-setting-select'
                onChange={(value) => axisChange('x', value)}
                options={[
                  { value: 'linear', label: 'Linear' },
                  { value: 'log', label: 'Log' }
                ]}
              />
            </Col>
          </Row>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>Begin</label>
            </Col>
            <Col span={14}>
              <InputNumber
                className='sp-setting-input'
                value={axis.xMin ? axis.xMin : 0}
                disabled={Object.keys(portSelect).length === 0 ? true : false}
                onChange={(value) => changeRange('xMin', value)}
                step={0.1}
                onKeyDown={(e) => axisRangeKeyDown(e, 'xMin')}
                onBlur={(e) => updateRange('xMin', e.target.value)}
                onFocus={savePrevRange}
              />
              <Select
                value={XSettingUnit}
                className='sp-unit-select'
                onChange={(value) => XUnitChange(value)}
                options={[
                  { value: 'Hz', label: 'Hz' },
                  { value: 'KHz', label: 'KHz' },
                  { value: 'MHz', label: 'MHz' },
                  { value: 'GHz', label: 'GHz' }
                ]}
              />
            </Col>
          </Row>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>End</label>
            </Col>
            <Col span={14}>
              <InputNumber
                className='sp-setting-input'
                value={axis.xMax ? axis.xMax : 0}
                disabled={Object.keys(portSelect).length === 0 ? true : false}
                onChange={(value) => changeRange('xMax', value)}
                step={0.1}
                onKeyDown={(e) => axisRangeKeyDown(e, 'xMax')}
                onBlur={(e) => updateRange('xMax', e.target.value)}
                onFocus={savePrevRange}
              />
              <Select
                value={XSettingUnit ? XSettingUnit : 'MHz'}
                className='sp-unit-select'
                onChange={(value) => XUnitChange(value)}
                options={[
                  { value: 'Hz', label: 'Hz' },
                  { value: 'KHz', label: 'KHz' },
                  { value: 'MHz', label: 'MHz' },
                  { value: 'GHz', label: 'GHz' }
                ]}
              />
            </Col>
          </Row>
        </Row>
        <Row onClick={() => showAxisSetting('yShow')} className='sp-axis-title'>
          {axis.yShow ? <DownOutlined className="result-setting-expand-icon" /> : <RightOutlined className="result-setting-expand-icon" />}
          <span className='setting-input-title'>Y axis -- {getYLabel({ value, yScale: axis.yScale, param: 'Z' })}</span>
          {/* TODO unit <span>(db)</span>*/}
        </Row>
        <Row style={{ display: axis.yShow ? 'block' : 'none' }} className='sp-axis-content'>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>Scale</label>
            </Col>
            <Col span={14}>
              <Select
                value={axis.yScale}
                className='sp-setting-select'
                onChange={(value) => axisChange('y', value)}
              >
                <Option value='linear' style={{ display: value !== 'ph' ? 'block' : 'none' }}>Linear</Option>
                <Option value="log" style={{ display: value === 'am' ? 'block' : 'none' }}>Log</Option>
                <Option value="db" style={{ display: value === 'am' && parameter === 's' ? 'block' : 'none' }}>dB</Option>
                <Option value="radians" style={{ display: value === 'ph' ? 'block' : 'none' }}>Radian</Option>
                <Option value="degrees" style={{ display: value === 'ph' ? 'block' : 'none' }}>Degree</Option>
              </Select>
            </Col>
          </Row>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>Begin</label>
            </Col>
            <Col span={14}>
              <InputNumber
                className='sp-setting-input'
                value={axis.yMin ? axis.yMin : 0}
                disabled={Object.keys(portSelect).length === 0 ? true : false}
                onChange={(value) => changeRange('yMin', value)}
                step={0.1}
                onKeyDown={(e) => axisRangeKeyDown(e, 'yMin')}
                onBlur={(e) => updateRange('yMin', e.target.value)}
                onFocus={savePrevRange}
              />
              <Select
                defaultValue='Ω'
                className='sp-unit-select'
                options={[{ value: 'Ω', label: 'Ω' }]}
              />
            </Col>
          </Row>
          <Row {...attr}>
            <Col span={10}>
              <label className='setting-input-lable padding-left-42'>End</label>
            </Col>
            <Col span={14}>
              <InputNumber
                className='sp-setting-input'
                value={axis.yMax ? axis.yMax : 0}
                disabled={Object.keys(portSelect).length === 0 ? true : false}
                onChange={(value) => changeRange('yMax', value)}
                step={0.1}
                onKeyDown={(e) => axisRangeKeyDown(e, 'yMax')}
                onBlur={(e) => updateRange('yMax', e.target.value)}
                onFocus={savePrevRange}
              />
              <Select
                defaultValue='Ω'
                className='sp-unit-select'
                options={[{ value: 'Ω', label: 'Ω' }]}
              />
            </Col>
          </Row>
        </Row>
      </div>
    </div>
  );

}

export default SparameterSetting;